/** Shared Cultiv brand asset CDN (fonts, marketing images). Single source of
    truth — imported by the root layout and app/[locale]/cultiv/site.ts. */
export const BRAND_CDN = 'https://d1oytcss5issfa.cloudfront.net';

/** Self-hosted tab icons — `/cultiv-icon.svg` busts cached Koqoon `/favicon.svg`. */
export const CULTIV_FAVICON = '/cultiv-icon.svg';
export const CULTIV_APPLE_TOUCH = '/apple-touch-icon.png';
